import type { SelfServiceApiContext } from './types';

interface LookupResult {
  ok: boolean;
  locationId: number;
  locationName: string;
  date: string;
  time: string;
}

const MOCK_LOCATIONS = [
  { id: 1001, name: 'Borgerservice Rantzausgade' },
  { id: 1002, name: 'Norrebro Bibliotek' },
  { id: 1003, name: 'Bispebjerg Bibliotek' }
] as const;

const createFallbackResult = async (ctx: SelfServiceApiContext, bookingRef: string): Promise<LookupResult> => {
  await ctx.delay(ctx.config.delays.getState);
  const idx = Math.abs([...bookingRef].reduce((acc, char) => acc + char.charCodeAt(0), 0)) % MOCK_LOCATIONS.length;
  const location = MOCK_LOCATIONS[idx];
  const today = new Date();
  today.setDate(today.getDate() + 2);
  const date = today.toISOString().split('T')[0];
  return {
    ok: true,
    locationId: location.id,
    locationName: location.name,
    date,
    time: '10:00'
  };
};

export const lookupBooking = async (
  ctx: SelfServiceApiContext,
  bookingRef: string,
  phone: string,
  sessionId?: string | null
): Promise<LookupResult> => {
  try {
    const theSession = sessionId ?? 'session';
    const response = await ctx.httpClient.postJSON(`${ctx.baseUrl}/selfservice/${theSession}/cancel/lookup`, { bookingRef, phone });
    if (response.ok) {
      const data = await response.json();
      return {
        ok: true,
        locationId: Number(data.location),
        locationName: data.locationName,
        date: data.date,
        time: data.time
      };
    }
  } catch {
    // fall back to mock data below
  }

  return createFallbackResult(ctx, bookingRef);
};

export const cancelBooking = async (ctx: SelfServiceApiContext, sessionId: string | null, bookingRef: string): Promise<{ ok: boolean }> => {
  try {
    const theSession = sessionId ?? 'session';
    const response = await ctx.httpClient.postJSON(`${ctx.baseUrl}/selfservice/${theSession}/cancel`, { bookingRef });
    if (response.ok) {
      return { ok: true };
    }
  } catch {
    // ignore, fall through to optimistic response
  }

  await ctx.delay(ctx.config.delays.saveState);
  return { ok: true };
};
